import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../utils/checkout';
export function PricingSection() {
  return <section id="offre" className="scroll-mt-20 bg-brand-sandSoft px-4 py-20 md:py-28" data-id="element-126" data-mp="1ei8nbq1m3lum">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-127" data-mp="1ege0u7aozlof">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-sageInk" data-id="element-128" data-mp="1ja0cpx917lj6">TEMPS LIMITÉ</p>
        <h2 className="mb-12 text-3xl font-black text-brand-slate md:text-4xl" data-id="element-129" data-mp="1n9r3i0yk61np">🏷️ Offre de Lancement</h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-terracotta bg-white p-8 pt-10 shadow-xl md:p-12" data-id="element-130" data-mp="1s82be65am23a">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-terracotta px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-slate" data-id="element-131" data-mp="227t7gc9i4p5h">
            PILATES REFORMER PRÊT™️
          </div>
          <div className="space-y-4 text-left" data-id="element-132" data-mp="7ubs3cj92ylj">
            <LignePrix label="6 Tomes Complets (360 pages)" price="87 €" data-id="element-133" data-mp="1mgenfk0zkwd2" />
            <LignePrix label="5 Bonus Exclusifs" price="91 €" data-id="element-134" data-mp="1mirb8dtfe0y1" />
            <LignePrix label="Mises à Jour à Vie" price="39 €" data-id="element-135" data-mp="1hp6d8lru16yu" />
            <div className="flex items-center justify-between pt-1 text-sm font-bold" data-id="element-136" data-mp="1cqll79mqhtlh">
              <span data-id="element-137" data-mp="17rs5rbnvzsio">VALEUR TOTALE</span>
              <span className="text-brand-terracottaInk line-through" data-id="element-138" data-mp="17sto8178fhaf">217 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-sand py-7" data-id="element-139" data-mp="25f0q33c5ivj3">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-sageInk" data-id="element-140" data-mp="20g67o2i3j8zi">AUJOURD&apos;HUI SEULEMENT</p>
            <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-terracottaInk md:text-7xl" data-id="element-141" data-mp="1vgbdnq30y3a8">
              19 €
            </p>
            <p className="mt-2 text-xs font-semibold text-brand-gray" data-id="element-142" data-mp="k27ocx7dt3bi">(paiement unique, TVA incluse)</p>
          </div>
          <CTAButton href={CHECKOUT_URL} className="w-full py-5 text-base md:text-lg" data-id="element-143" data-mp="g02xu7c8cmt3">
            JE PRENDS PILATES REFORMER PRÊT MAINTENANT
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-144" data-mp="hforjhbh1i34">
            Paiement unique et sécurisé · Accès immédiat · Aucun abonnement
          </p>
        </div>
      </Reveal>
    </section>;
}
function LignePrix({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-sand pb-4 text-sm" data-id="element-145" data-mp="cgu3o0ynd3c5">
      <span className="font-medium" data-id="element-146" data-mp="3uul5aufjjvhl">{label}</span>
      <span className="whitespace-nowrap font-bold text-brand-slate line-through" data-id="element-147" data-mp="3i8li6x37qbw">{price}</span>
    </div>;
}